<template>
  <page :back-to="getPreviousUrl" title="Send notification" size="is-widescreen">
    <div>
      <div class="columns">
        <div class="column is-7">
          <div class="box">
            <p class="title is-5">Recipient:</p>

            <b-field label="Recipient Type">
              <b-select v-model="form.recipient_type">
                <option value="user">User</option>
                <option value="channel">Channel</option>
              </b-select>
            </b-field>

            <b-field v-if="form.recipient_type === 'user'" label="User">
              <user-select
                @change="(user) => (form.to = user.id)"
              ></user-select>
            </b-field>

            <b-field v-if="form.recipient_type === 'channel'" label="Channel">
              <b-select v-model="form.to">
                <option
                  v-for="channel in channels.data"
                  :key="channel.id"
                  :value="channel.id"
                  >{{ channel.name }} - {{ channel.description }}</option
                >
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <p class="title is-5">AutoFill</p>

            <b-field>
              <b-select v-model="autoFill">
                <option value="custom">Custom</option>
                <option value="issue">Issue</option>
              </b-select>
            </b-field>

            <b-field v-if="autoFill === 'issue'" label="Pick issue">
              <issue-select @change="autoFillByIssue"></issue-select>
            </b-field>
          </div>

          <div class="box">
            <b-field label="Priority">
              <b-select v-model="form.priority">
                <option value="normal">Normal</option>
                <option value="high">High</option>
              </b-select>
            </b-field>

            <b-field label="Title">
              <b-input
                type="text"
                v-model="form.title"
                placeholder="Notification title"
              ></b-input>
            </b-field>

            <b-field
              label="Notification subtitle"
              message="Subtitle only visible on iOS."
            >
              <b-input type="text" v-model="form.subtitle"></b-input>
            </b-field>

            <b-field
              label="Notification body"
              message="Body only visible on iOS. max length: 160."
            >
              <b-input type="textarea" v-model="form.body" rows="2"></b-input>
            </b-field>
          </div>

          <div class="box">
            <p class="title is-5">Link</p>

            <b-field label="Image url">
              <b-input icon="image" v-model="form.image_url"></b-input>
            </b-field>

            <b-field label="Link">
              <b-input
                icon="link"
                v-model="form.link"
                :placeholder="`${$store.state.appName}://`"
              ></b-input>
            </b-field>
          </div>

          <div class="box">
            <p class="title is-5">Schedule</p>
            <b-field label="Date">
              <datetimepicker v-model="form.date"></datetimepicker>
            </b-field>
          </div>

          <button
            class="button is-primary is-medium mb-8"
            :disabled="form.processing"
            @click="submit"
          >
            <b-icon icon="send" size="is-small"></b-icon>
            <span>Send notification</span>
          </button>
        </div>

        <div class="column">
          <p class="title is-6">IOS</p>
          <div class="notification has-large-shadow has-background-white">
            <div class="media">
              <div class="media-content">
                <div>
                  <strong>{{ form.title }}</strong>
                </div>
                <div>
                  <strong>{{ form.subtitle }}</strong>
                </div>
                <p v-if="form.body">{{ form.body.substring(0, 116) }}</p>
              </div>

              <div class="media-right">
                <figure
                  class="image is-32x32 is-pulled-right"
                  style="
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img :src="form.image_url" />
                </figure>
              </div>
            </div>
          </div>

          <hr />

          <p class="title is-6">Android</p>
          <div class="notification has-large-shadow has-background-white">
            <div class="media">
              <div class="media-content">
                <h1 class="title is-5 is-marginless">{{ form.title }}</h1>
                <p v-if="form.body">{{ form.body.substring(0, 35) }}...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import IssueSelect from "./../../components/selectors/IssueSelect";
import UserSelect from "./../../components/selectors/UserSelect";

export default {
  components: {
    IssueSelect,
    UserSelect,
  },

  props: {
    notification: {
      type: Object,
    },
  },

  data() {
    return {
      autoFill: "custom",

      userDevices: new window.RemoteCollection("/account/api/devices").load(),

      channels: new window.RemoteCollection("/admin/api/channels").load(),

      to: null,
      sending: false,

      form: new window.Form({
        recipient_type: "user",
        to: null,
        title: this.notification ? this.notification.title : "",
        priority: this.notification ? this.notification.priority : "high",
        subtitle: this.notification ? this.notification.subtitle : null,
        body: this.notification ? this.notification.body : null,
        image_url: this.notification ? this.notification.image_url : null,
        link: this.notification ? this.notification.link : null,
      }),
    };
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    autoFillByIssue(issue) {
      this.form.title = issue.title;
      this.form.body = issue.description
        .replace(/(\r\n|\n|\r)/gm, " ")
        .substring(0, 160)
        .trim();
      this.form.image_url = issue.cover_image_url;
      this.form.deep_link = this.$store.state.config.app.dl + `://q?type=issue&id=${issue.id}`;
    },

    submit() {
      return this.send();
    },

    send() {
      this.sending = true;

      this.form
        .post("/admin/api/notifications")
        .then(() => {
          this.sending = false;
          this.$buefy.toast.open("Notification sent.");
          this.$router.push("/pns");
        })
        .catch(() => {
          this.sending = false;
        });
    },
  },
};
</script>
